var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFruitPeaches(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_1280)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6561 7.84882C30.5026 5.89895 26.3095 7.49925 24.2946 8.69904C24.9784 7.5205 25.8638 6.4711 26.9103 5.59857C28.8162 3.94732 31.1578 3.84895 33.7173 3.59951C34.5886 2.59822 34.4252 1.74977 33.7173 0.899551C30.7767 1.14899 28.1628 1.59869 26.2006 3.64869C25.3888 4.50422 24.6931 5.46278 24.1313 6.49972C23.8941 7.02671 23.8608 7.10049 23.5323 7.64857C23.3144 8.19839 23.0422 8.8466 22.8226 9.5475C22.2236 8.84835 18.9562 5.39831 11.3324 6.79835C1.74816 8.49702 0.279608 17.4963 1.25981 24.1979C2.45784 32.296 10.4084 39.9479 16.9958 43.2486C19.2303 44.3483 21.2996 45 22.8788 45C29.468 45 42.9713 35.0504 44.496 24.1979C45.3129 18.4976 44.2237 12.446 39.6512 9.29805C38.7338 8.66297 37.7234 8.17408 36.6561 7.84882ZM15.1461 21.9986C15.2023 23.7482 15.5817 25.4978 16.0718 27.2984C16.5602 29.1007 17.2154 30.8503 17.7055 32.7492C16.3378 31.2964 15.1993 29.6438 14.3292 27.8482C13.5124 26.0476 12.9134 24.0978 12.8045 22.046C12.7482 20.0469 13.1856 17.8951 14.3819 16.1454C15.5692 14.4001 17.2596 13.0577 19.2285 12.2966C17.8671 13.7968 16.778 15.2952 16.0701 16.9465C15.3094 18.5485 15.0916 20.249 15.1461 21.9986Z",
    fill: "#E5914B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.375 6.49974C22.3064 5.63538 22.0054 4.80565 21.5037 4.09842C19.38 1.29833 15.568 -0.301968 11.865 0.0476037C11.6472 0.746747 11.8088 1.44765 12.0811 2.09936C13.1702 4.74837 16.0581 6.69825 19.1604 6.84932C19.8138 6.90026 20.4673 6.84932 21.0663 7.04782C21.3386 7.14795 21.6109 7.3482 21.776 7.64859C21.5582 8.19842 22.9196 5.49846 22.375 6.49974Z",
    fill: "#9CCE6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_1280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFruitPeaches);
export default __webpack_public_path__ + "static/media/ic-fruit-peaches.b92df6e5d4a120c71bf56441161140cf.svg";
export { ForwardRef as ReactComponent };